import React, { useState } from 'react';
import { Button, Input, Modal, Space, Table } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function UserSales({ userName }) {
    const { business, GET_USER_SALE, users } = usePersistedStore();
    const general = useGeneralStore();

    const visible = general.view.userSalesModal;
    const sales = users.sales;
    const salesLoading = users.saleLoading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}>
                        جستجو
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>ریست</Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (text),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    function postRecalculateMarketerComission(insuranceRequestId, userName) {
        UserServices.postRecalculateMarketerComission(insuranceRequestId, token).then((res) => {
            getUserSale(userName)
            general.NotifSuccess('کارمزد بازاریاب، مجددامحاسبه شد');
        }).catch((error) => {

        })

    }

    function getUserSale(Username) {
        UserServices.getUserSale(Username, token).then((res) => {
            GET_USER_SALE(res.data.Sales)
        }).catch((error) => {

        })
    }

    const columns = [
        {
            title: "محاسبه مجدد کارمزد",
            dataIndex: "InsuranceRequestId",
            key: "InsuranceRequestId",
            render: Id => (
                <Button type="link" className="recalculateCommission" onClick={() => postRecalculateMarketerComission(Id, userName)}>
                    محاسبه کارمزد
                </Button>)
        }
        ,
        {
            title: "نام بیمه گزار",
            dataIndex: "FullName",
            key: "FullName",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.FullName ? first = a.FullName : first = '';
                b.FullName ? second = b.FullName : second = '';
                return first.localeCompare(second)
            },
            ...getColumnSearchProps('FullName', 'نام بیمه گزار'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>
        },
        {
            title: "شماره درخواست",
            dataIndex: "InsuranceRequestId",
            key: "InsuranceRequestId",
            sorter: (a, b) => a.InsuranceRequestId - b.InsuranceRequestId,
            ...getColumnSearchProps('InsuranceRequestId', 'شماره درخواست'),
            render: text => strings.getFarsiNum(text)
        },
        {
            title: "رشته",
            dataIndex: "InsuranceTypeName",
            key: "InsuranceTypeName",
            sorter: (a, b) => a.InsuranceTypeName.localeCompare(b.InsuranceTypeName),
            ...getColumnSearchProps('InsuranceTypeName', 'رشته')
        },
        {
            title: "وضعیت",
            dataIndex: "RequestStatus",
            key: "RequestStatus",
            sorter: (a, b) => a.RequestStatus - b.RequestStatus,
            ...getColumnSearchProps('RequestStatus', 'وضعیت')
        },
        {
            title: "مدت بیمه نامه",
            dataIndex: "DurationTitle",
            key: "DurationTitle",
            sorter: (a, b) => a.DurationTitle - b.DurationTitle,
            ...getColumnSearchProps('DurationTitle', 'مدت بیمه نامه')
        },
        {
            title: "شرکت بیمه",
            dataIndex: "CompanyName",
            key: "CompanyName",
            sorter: (a, b) => a.CompanyName - b.CompanyName,
            ...getColumnSearchProps('CompanyName', 'شرکت بیمه')
        },
        {
            title: "مبلغ پرداختی",
            dataIndex: "Payment",
            key: "Payment",
            sorter: (a, b) => a.Payment - b.Payment,
            ...getColumnSearchProps('Payment', 'مبلغ پرداختی'),
            render: data => data && strings.currencyFormat(data) + ' ریال'
        },
        {
            title: "حق بیمه نهایی",
            dataIndex: "ActualAmount",
            key: "ActualAmount",
            sorter: (a, b) => a.ActualAmount - b.ActualAmount,
            ...getColumnSearchProps('ActualAmount', 'حق بیمه نهایی'),
            render: data => data && strings.currencyFormat(data) + ' ریال'
        },
        {
            title: "مبلغ کارمزد",
            dataIndex: "CommissionAmount",
            key: "CommissionAmount",
            sorter: (a, b) => a.CommissionAmount - b.CommissionAmount,
            ...getColumnSearchProps('CommissionAmount', 'مبلغ کارمزد'),
            render: data => data && strings.currencyFormat(data) + ' ریال'
        },
        {
            title: "تاریخ صدور",
            dataIndex: "IssuanceDate",
            key: "IssuanceDate",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.IssuanceDate ? first = a.IssuanceDate : first = '';
                b.IssuanceDate ? second = b.IssuanceDate : second = '';
                return first.localeCompare(second)
            },
            render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "تاریخ ایجاد",
            dataIndex: "CreationTime",
            key: "CreationTime",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.CreationTime ? first = a.CreationTime : first = '';
                b.CreationTime ? second = b.CreationTime : second = '';
                return first.localeCompare(second)
            },
            render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "تاریخ خرید",
            dataIndex: "BuyDate",
            key: "BuyDate",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.BuyDate ? first = a.BuyDate : first = '';
                b.BuyDate ? second = b.BuyDate : second = '';
                return first.localeCompare(second)
            },
            render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        }
    ];

    return (
        <Modal
            width={1000}
            title="لیست فروش های کاربر"
            className="custom-table"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleUserSalesModal()}>
            <Table
                style={{ overflowX: 'scroll' }}
                bordered
                columns={columns}
                loading={salesLoading}
                rowKey="InsuranceRequestId"
                scroll={true}
                dataSource={sales}
            />
        </Modal>
    )
}

